/*
 * Hippy Chick Ibiza - Solar Mirage SS27 wholesale request page
 * Replaces only the existing editorial content above the Shopify request form.
 * The existing Shopify form, header and footer stay untouched.
 */
(function () {
  'use strict';

  var REQUEST_PATH = '/pages/solar-mirage-ss27-wholesale';
  var scriptSource = document.currentScript && document.currentScript.src
    ? document.currentScript.src
    : '';
  if (window.location.pathname !== REQUEST_PATH) return;
  if (window.__hcRequestPagePdfExactInstalled) return;
  window.__hcRequestPagePdfExactInstalled = true;

  function install() {
    var main = document.querySelector('#MainContent');
    if (!main) return;

    var assetBase = scriptSource ? new URL('.', scriptSource).href : '';
    var formSection = main.querySelector(':scope > .shopify-section.spaced-section');

    if (!formSection) {
      var sections = Array.prototype.slice.call(main.children);
      formSection = sections.find(function (section) {
        return section.querySelector && (
          section.querySelector('form') ||
          section.querySelector('.shopify-app-block') ||
          section.id.indexOf('form') !== -1
        );
      });
    }

    if (!formSection) return;

    Array.prototype.forEach.call(main.querySelectorAll(':scope > .hc-b2b-section'), function (section) {
      section.hidden = true;
      section.setAttribute('aria-hidden', 'true');
    });

    var style = document.createElement('style');
    style.id = 'hc-request-page-exact-style';
    style.textContent = [
      'body.hc-request-page-exact-active{background:#f7f2e8;}',
      '#MainContent{overflow:hidden;}',
      '#hc-request-page-exact{width:100%;margin:0;padding:0;background:#fff;}',
      '.hc-request-page-exact__canvas{width:min(1440px,100%);margin:0 auto;line-height:0;background:#fff;}',
      '.hc-request-page-exact__page{position:relative;width:100%;margin:0;padding:0;line-height:0;}',
      '.hc-request-page-exact__page img{display:block;width:100%;height:auto;margin:0;padding:0;border:0;}',
      '.hc-request-page-exact__cta{position:absolute;z-index:2;left:35.8%;top:75.1%;width:28.5%;height:8.2%;display:block;overflow:hidden;text-indent:-9999px;white-space:nowrap;cursor:pointer;}',
      '.hc-request-page-exact__cta:focus-visible{outline:3px solid #3d3733;outline-offset:3px;}',
      '#hc-request-page-exact+section{scroll-margin-top:24px;}',
      '@media(max-width:749px){',
      '  .hc-request-page-exact__canvas{width:100%;}',
      '  .hc-request-page-exact__cta{left:35.2%;top:74.8%;width:30%;height:9%;}',
      '}',
      '@media(prefers-reduced-motion:reduce){html{scroll-behavior:auto!important;}}'
    ].join('');
    document.head.appendChild(style);

    var stage = document.createElement('section');
    stage.id = 'hc-request-page-exact';
    stage.setAttribute('aria-label', 'Solar Mirage SS27 wholesale introduction');

    var canvas = document.createElement('div');
    canvas.className = 'hc-request-page-exact__canvas';

    var pageDimensions = [
      { width: 2160, height: 1440 },
      { width: 2160, height: 938 },
      { width: 2160, height: 1473 },
      { width: 2160, height: 1044 }
    ];

    [1, 2, 3, 4].forEach(function (pageNumber) {
      var page = document.createElement('div');
      page.className = 'hc-request-page-exact__page hc-request-page-exact__page--' + pageNumber;

      var image = document.createElement('img');
      image.src = assetBase + 'hc-request-page-' + pageNumber + '.webp';
      image.alt = pageNumber === 1
        ? 'Follow the sun through five stories - Solar Mirage SS27 wholesale'
        : pageNumber === 2
          ? 'The five Solar Mirage stories from Aqua Flow to Azure Breeze'
          : pageNumber === 3
            ? 'Sneak preview of the 2027 Hippy Chick collection'
            : 'Behind the scenes of the handmade production process in Bali';
      image.width = pageDimensions[pageNumber - 1].width;
      image.height = pageDimensions[pageNumber - 1].height;
      image.decoding = 'async';
      image.loading = pageNumber === 1 ? 'eager' : 'lazy';
      page.appendChild(image);

      if (pageNumber === 1) {
        var cta = document.createElement('a');
        cta.className = 'hc-request-page-exact__cta';
        cta.href = '#hc-wholesale-request-form';
        cta.textContent = 'Request wholesale access';
        cta.addEventListener('click', function (event) {
          event.preventDefault();
          formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        page.appendChild(cta);
      }

      canvas.appendChild(page);
    });

    stage.appendChild(canvas);
    formSection.id = formSection.id || 'hc-wholesale-request-form';
    formSection.before(stage);
    document.body.classList.add('hc-request-page-exact-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }
})();
